import React from "react";
import CustomRow from "../../shared/costum-row/costum-row";
import { Col } from "antd";
import Usp from "../usp/usp";
import useBreakpoints from "../../hooks/use-breakpoints";
import { BREAKPOINTS } from "../../constants/styles";
import { Gutter } from "antd/lib/grid/row";
import "./styles.scss";

interface UspsProps {
  layout?: "row" | "grid";
}

const Usps: React.FC<UspsProps> = ({ layout = "row" }) => {
  const currentBreakpoint = useBreakpoints();
  const isMobile = currentBreakpoint === BREAKPOINTS.MOBILE.type;
  const isTablet = currentBreakpoint === BREAKPOINTS.TABLET.type;

  // For row layout (home page)
  const rowColProps = {
    xxl: 5,
    xl: 5,
    lg: 5,
    md: 5,
    sm: 10,
    xs: 11,
  };

  // For grid layout (about us page)
  const gridColProps = {
    xxl: 12,
    xl: 12,
    lg: 12,
    md: 12,
    sm: 12,
    xs: 24,
  };

  const colProps = layout === "grid" ? gridColProps : rowColProps;
  const gutter: [number, number] =
    layout === "grid" ? [40, 40] : isMobile ? [0, 40] : [0, 0];

  return (
    <CustomRow
      gutter={gutter}
      isMarginNone={true}
      justify={"space-between"}
      className={`usps-container usps-${layout}`}
    >
      <Col {...colProps} className="usp-col">
        <Usp type="trust" />
      </Col>
      <Col {...colProps} className="usp-col">
        <Usp type="ambition" />
      </Col>
      <Col {...colProps} className="usp-col">
        <Usp type="adaptability" />
      </Col>
      <Col {...colProps} className="usp-col">
        <Usp type="enjoyment" />
      </Col>
    </CustomRow>
  );
};

export default Usps;
